import { Injectable } from '@angular/core';

import { download, generateCsv, mkConfig } from 'export-to-csv';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
@Injectable()
export class ExportService {
  constructor() {}

  public exportToCSV(fileName: string, header: string[], data: any) {
    const options = {
      filename: fileName,
      fieldSeparator: ',',
      quoteStrings: true,
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      //title: 'My Awesome CSV',
      useTextFile: false,
      useBom: true,
      compression: true,
      useKeysAsHeaders: true,
      headers: header,
    };

    const csvConfig = mkConfig(options);  // Pass the full options object
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  }

  public exportToPDF(fileName: string, header: string[], data: any) {
    var doc: any = new jsPDF();
    doc.autoTable({ head: [header], body: data });
    doc.autoTable({ head: [header], body: data });
    doc.save(fileName + '.pdf');
  }
  public exportToPDFFile(
    fileName: string,
    exportPDFHeading: string,
    todayDate: string,
    rollingWindow: string,
    labelFor: string,
    comparisonRanges: string,
    startAndendDateLabel: string,
    header: string[],
    data1: any,
    canvas: { toDataURL: () => any }
  ) {
    var doc: any = new jsPDF('p', 'pt', 'a4');
    let dataURL = canvas.toDataURL();
    // let dataURL1 = canvas1.toDataURL();
    doc.setFontSize(14);
    doc.setFontType('bold');
    doc.setTextColor('#061F37');
    doc.text(20, 30, exportPDFHeading);
    doc.setFontSize(11);
    doc.setFontType('Open Sans ');
    doc.text(500, 30, todayDate);
    doc.setFontSize(11);
    doc.setFontType('Open Sans Bold');
    var subline = labelFor + ' Report for the date range of ' + startAndendDateLabel + comparisonRanges;
    var lines = doc.splitTextToSize(subline, 450);
    doc.text(20, 60, lines);
    // doc.text(20, 60, labelFor + " Report for the date range of " + startAndendDateLabel + comparisonRanges);
    doc.setTextColor('#061F37');
    doc.text(20, 90, +rollingWindow + ' days count');
    doc.setTextColor('#737373');
    doc.setDrawColor(189, 195, 199); // draw gray lines
    // doc.rect(20, 20, 10, 10)
    doc.rect(20, 95, 550, 230); //drow rectangle
    //l, r , w, h
    doc.addImage(dataURL, 'JPEG', 50, 120, 500, 180);
    //doc.setDrawColor(150,150,150);
    // doc.text(300, 30, exportPDFHeading);
    // doc.addImage(dataURL1, 'JPEG', 300, 60, 230, 180)
    // {
    //   headerStyles: {
    //       lineWidth: 1,
    //       lineColor: [255, 0, 0]
    //   }},
    // doc.text(10, 300, 'Period activity per product');
    doc.autoTable({
      margin: { top: 350, right: 20, bottom: 50, left: 20 },
    });
    doc.autoTable({
      tableLineColor: [189, 195, 199],
      tableLineWidth: 0.75,
      styles: {
        cellPadding: 9,
      },
      margin: { right: 20, bottom: 50, left: 20 },
      headStyles: { fillColor: '#ffffff', textColor: '#737373' },
      head: [header],
      body: data1,
    });
    doc.setFontSize(12);
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageSize = doc.internal.pageSize;
      const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

      const footer = `Page ${i}`;
      doc.setFontType('Open Sans Bold');
      doc.setFontSize(12);
      doc.setTextColor('#061F37');
      doc.text('PAPI Admin Portal', 25, doc.internal.pageSize.height - 10);
      doc.text(footer, 540, doc.internal.pageSize.height - 10);
      // doc.addPage();
      // doc.text(10, 30, 'Period activity by product and partner');
      // data2.forEach(element => {
      //   doc.autoTable({ head: [header], body: element });
      // });
    }
    doc.save(fileName + '.pdf');
  }
  // public exportToXLSX(fileName: string, data) {
  //   var wb = XLSX.utils.book_new();

  //   wb.SheetNames.push("MFS Sheet");
  //   var ws_data = data; //store table data
  //   var ws = XLSX.utils.aoa_to_sheet(ws_data);

  //   wb.Sheets["MFS Sheet"] = ws;
  //   //added compression option to reduce the file size after download
  //   var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary',bookSST: true,compression:true
  //   });

  //   function s2ab(s) {
  //     var buf = new ArrayBuffer(s.length);
  //     var view = new Uint8Array(buf);
  //     for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
  //     return buf;
  //   }
  //   saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');
  // }

  public exportToXLSX(fileName: string, data: any) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    var sheetName = 'data';
    if (fileName.startsWith('Partner')) {
      sheetName = 'Partner Portal';
    }
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    // const workbook: XLSX.WorkBook = {
    //   Sheets: { data: worksheet },
    //   SheetNames: ["data"],
    // };
    // console.log(data.length);

    let fmt = '#,##0.0000';

    var range = { s: { r: 1, c: 1 }, e: { r: data.length, c: 100 } }; // /* run in loop  */
    for (var R = range.s.r; R <= range.e.r; ++R) {
      for (var C = range.s.c; C <= range.e.c; ++C) {
        var cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
        if (!cell || cell.t != 'n') continue; // only format numeric cells
        //  let fmt = "0.00";
        cell.z = fmt;
        // if(cell.v == 0){
        //   let fmt = ' ';
        //     cell.z = fmt;
        // } else {
        //   let fmt = "0.00";
        //   cell.z = fmt;
        // }
      }
    }

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      compression: true,
    });

    this.save(excelBuffer, fileName);
  }
  save(buffer: any, fileName: string) {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8',
    });

    saveAs(data, fileName + '.xlsx');
  }
}
